
import type { AsyncDataOptions } from '#app';
import type { FetchOptions } from 'ofetch';
import FetchFactory from '../factory';


class MissionsModule extends FetchFactory<IMission> {
  private RESOURCE = '/missions';

  async getMissions(
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<IMission[]>
  ) {
    return useAsyncData(
      () => {
        return this.call(
          `${this.RESOURCE}`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

  async getMission(
    id: string,
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<IMission>
  ) {
    return useAsyncData(
      () => {
        return this.call(
          `${this.RESOURCE}/${id}`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

  async userDoableMissions(
    filter?: string,
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<IMission[]>>
  ) {
    return useAsyncData(
      () => {
        return this.call(
          `${this.RESOURCE}/user-doable-missions?${filter}`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };
}

export default MissionsModule;
